import React from 'react';
import MyCarousel from "../MyCarousel";
import '../styles/Resume.css'


const Resume = ({resumeData}) => {
    React.useEffect(() => {
        document.getElementsByTagName('title')[0].innerHTML = 'Ainsley Davis 2026 - Resume'
    }, [])
    const myImages = [
        './slideshow3/1.png',
        './slideshow3/2.jpg',
        './slideshow3/3.jpg',
        './slideshow3/4.jpg',
        './slideshow3/5.jpg',
        './slideshow3/6.jpg',
        './slideshow3/7.jpg',
        './slideshow3/8.png',
        './slideshow3/9.jpg',
    ];
    return (
        <>
            <div className="floating-container">
                <div className="resume-info">
                    <h1 className="name-title">{resumeData.header.name}</h1>
                    <p className="class-year">Class of {resumeData.header.classYear}</p>
                    <p className="info-item">{resumeData.header.candidate}</p>
                    {resumeData.header.location.map((val, index) => (
                        <p className="info-item" key={val + index}>{val}</p>
                    ))}
                    <p className="info-item">Phone: {resumeData.header.contact.phone}</p>
                    <p className="info-item">Email: {resumeData.header.contact.email}</p>
                    <p className="info-item">USEF: {resumeData.header.USEF}</p>
                </div>

                <div style={{maxWidth: '100%'}} className="image-container">
                    <MyCarousel images={resumeData.carouselImages}/>
                </div>


                <div className="resume-section">
                    <h2 className="section-title">Trainers</h2>
                    {resumeData.trainers.map((trainer, index) => (
                        <div className="trainer" key={trainer.name + '-' + index}>
                            <p className="trainer-name">{trainer.name}, {trainer.years}</p>
                            <p className="trainer-contact">{trainer.contact}</p>
                        </div>
                    ))}
                </div>


                <div className="resume-section">
                    <h2 className="section-title">Clinics and Camps</h2>
                    <ul className="clinic-list">
                        {resumeData.clinics.map((clinic, index) => (
                            <li key={index + clinic}>{clinic}</li>
                        ))}
                    </ul>
                </div>

                <div className="resume-section">
                    {
                        Object.keys(resumeData.showSchedule).map((year, index) => (
                            <div key={year + index}>
                                <h2 className="section-title">{year} Show Schedule</h2>
                                <ul className="schedule-list">
                                    {resumeData.showSchedule[year].map((showSchedule, index) => (
                                        <li key={index + showSchedule}>{showSchedule}</li>
                                    ))}
                                </ul>
                            </div>

                        ))
                    }

                </div>

                <div className="resume-section">
                    <h2 className="section-title">Highlight Achievements</h2>
                    {
                        (Object.keys(resumeData.achievements).sort((a, b) => parseInt(b) - parseInt(a))).map((year, index) => (
                            <div className="achievement-group" key={year + 2024 * Math.random()}>
                                <h3 className="achievement-year">{year}</h3>
                                {resumeData.achievements[year].map((achievement, index) => {
                                    console.log(achievement)
                                    return (
                                        <ul className="achievement-list" key={achievement.title + index}>
                                            <li className="achievement-title">{achievement.title}</li>
                                            {achievement.details.map((title, index) => {
                                                if (title == "")
                                                    return <></>
                                                return (<li key={index + title}>{title}</li>)
                                            })}
                                        </ul>
                                    )
                                })}
                            </div>
                        ))
                    }
                </div>
            </div>
        </>
    )
        ;
};

export default Resume;